// ui.frontend/src/containers/aem/HelpArticle/index.tsx
import { HelpArticleProps } from './config';
import InPageNavigation from '../InPageNavigation';
import { bPadding, hPadding } from '../InPageNavigation/config';

const HelpArticle = ({ faqArticleTitle, answerField = '', links }: HelpArticleProps) => {
  return (
    <>
      <div className="tu-help-article">
        <h1>{faqArticleTitle}</h1>
        <InPageNavigation
          links={links}
          horizontalPadding={hPadding.fullWidth}
          bottomVerticalPadding={bPadding.small}
        />
        <div className="module module--rich-text">
          {/* START rich-text module content */}
          {/* generic rich text module */}
          <div
            className="rich-text"
            dangerouslySetInnerHTML={{
              __html: answerField,
            }}
          ></div>
          {/* END rich-text module content */}
        </div>
      </div>
    </>
  );
};

export default HelpArticle;